import { File } from '../file';

/**
 * Model definition for Social Meta
 */
export interface InternSocialMeta {
  __component: 'intern.social-meta';
  id: string;
  title?: string;
  description?: string;
  type: 'website' | 'article';
  media?: File;
}

export function isInternSocialMeta(obj: { __component?: string }): obj is InternSocialMeta {
  return obj.__component === 'intern.social-meta';
}
